<template>
  <main class="page-container">
  <section class="mt-5">
    <UiElementContactezNousEmbed/>
  </section>
  <section class="bg-primary-600">
    <div class="container-xl py-40 px-xl-0 infoCards-container">
      <div class="text-center pb-32">
        <h2 class="h3 text-white">
          Vends ta voiture rapidement, simplement et gratuitement
        </h2>
        <p class="text-white">
          Une plateforme simple et gratuite pour mettre ta voiture en avant rapidement
        </p>
      </div>
      <ul class="list-unstyled row d-flex justify-content-center align-items-center">

        <li v-for="( item, index) in content" :key="index"
          class="col-sm-5 col-xl-3 d-flex flex-column flex-xl-row align-items-center gap-2 px-lg-4 px-xl-1">
          <div class="influo-cards">
            <div class="card-avatar mx-auto">
              <span class="material-symbols-rounded fsz-20">{{ item.icon }}</span>
            </div>
            <h6 class="mt-2">{{ item.title }}</h6>
            <p class="fsz-12 mt-2">
              {{ item.discription }}
            </p>
          </div>
          <span v-if="3 != index" :class="index == 2 ? 'd-xl-block d-sm-none' : 'd-block'" class=" circlesSvg">
            <svg xmlns="http://www.w3.org/2000/svg" width="43" height="8" viewBox="0 0 43 8">
              <g id="Group_90" data-name="Group 90" transform="translate(-624 -1646.99)">
                <circle id="Ellipse_6" data-name="Ellipse 6" cx="4" cy="4" r="4" transform="translate(624 1646.99)"
                  fill="#FFF" />
                <circle id="Ellipse_7" data-name="Ellipse 7" cx="4" cy="4" r="4" transform="translate(636 1646.99)"
                  fill="#FFF" opacity="0.697" />
                <circle id="Ellipse_8" data-name="Ellipse 8" cx="4" cy="4" r="4" transform="translate(647 1646.99)"
                  fill="#FFF" opacity="0.449" />
                <circle id="Ellipse_9" data-name="Ellipse 9" cx="4" cy="4" r="4" transform="translate(659 1646.99)"
                  fill="#FFF" opacity="0.302" />
              </g>
            </svg>
          </span>

        </li>



      </ul>
      <LazyDialogsToast  />
      <div class="d-flex justify-content-center mt-32">
        <NuxtLink class="btn btn-outline-primary-600 py-12 d-flex align-items-center justify-content-center medium-btn fsz-14" to="/listing-form">
          <span class="material-symbols-rounded fsz-18 me-1">{{ icons.arrow }}</span>
          Vendre ma voiture maintenant
        </NuxtLink>

      </div>
    </div>
  </section>
  <NuxtLayout name="marks-footer"/>
</main>
</template>

<script setup lang="ts">
const runTimeConfig = useRuntimeConfig();
const route = useRoute();

definePageMeta({
layout: "terms-layout",
});

const icons = reactive({
  arrow: 'arrow_forward',
  camera: 'photo_camera',
  car: 'directions_car',
  chat: 'sms',
  dollarOutline: 'payments',
});

const content = reactive([
{
  icon: icons.camera,
  title: 'Préparation',
  discription: 'Préparez votre véhicule pour la vente en rassemblant toutes les informations et documents nécessaires.'
},
{
  icon: icons.car,
  title: 'Création de l’annonce',
  discription: 'Utilisez notre interface conviviale pour créer une annonce détaillée qui met en valeur les caractéristiques uniques de votre voiture.'
},
{
  icon: icons.chat,
  title: 'Visite',
  discription: 'Attirez des acheteurs potentiels grâce à une visibilité maximale. Les intéressés peuvent explorer votre annonce en détail et prendre contact avec vous.'
},
{
  icon: icons.dollarOutline,
  title: 'Vente',
  discription: 'Finalisez la transaction en toute sécurité. Notre plateforme facilite le processus, de la négociation à la conclusion de la vente, pour une expérience fluide et transparente.'
},
])

const seoUrl = ref();
const seoImage = ref();

const seoTitle = `Contactez TopAuto Tunisie | Support et Assistance`;
const seoDescription = `Besoin d’aide pour vendre ou acheter une voiture ? Contactez l’équipe TopAuto en Tunisie. Notre support est à votre écoute pour toute question ou demande d’assistance.`;
seoUrl.value = `${runTimeConfig.public.clientBaseUrl}${route.fullPath}`;
seoImage.value = `${runTimeConfig.public.clientBaseUrl}/_nuxt/assets/images/logos/Logo.png`;

useHead({
  title: seoTitle,
  link: [
    {
      rel: 'canonical',
      href: seoUrl
    }
  ],
  meta: [
    {
      name: 'description',
      content: seoDescription
    },
    {
      property: 'og:title',
      content: seoTitle
    },
    {
      property: 'og:type',
      content: 'website'
    },
    {
      property: 'og:description',
      content: seoDescription
    },
    {
      property: 'og:url',
      content: seoUrl
    },
    {
      property: 'og:image',
      content: seoImage
    },
    {
      property: 'og:site_name',
      content: 'TopAuto'
    }
  ]
});

</script>

<style lang="scss" scoped>

</style>